import state from './moduleBankAccountState.js'
import mutations from './moduleBankAccountMutations.js'
import actions from './moduleBankAccountActions.js'
import getters from './moduleBankAccountGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
